const defaultState = {};

const mutations = {
    setRiskAnalysisState(state, riskAnalysis) {
        Object.assign(state, riskAnalysis);
    },
    resetRiskAnalysisState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    async getRiskAnalysisInfo({ commit, dispatch }, riskAnalysisId) {
        try {
            const { data } = await this.$rq.getRiskAnalysis(riskAnalysisId);
            commit('setRiskAnalysisState', data);
        } catch (err) {
            dispatch('resetRiskAnalysisInfo');
        }
    },
    resetRiskAnalysisInfo({ commit }) {
        commit('resetRiskAnalysisState');
    },
};

const getters = {
    riskAnalysis: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
